import { getUtmLink } from "helpers";
import { images, landingImages } from "helpers/images";

const Footer = () => {
  const footerLinks = [
    {
      title: "QUICK LINKS",
      links: [
        { label: "Packages", to: "/packages", type: "link" },
        { label: "Blogs & News", to: "/blogs", type: "link" },
        { label: "About us", to: "/about-us", type: "link" },
        { label: "Careers", to: "/careers", type: "link" },
        { label: "Testimonials", to: "/testimonials", type: "link" },
        { label: "Contact us", to: "/contact-us", type: "link" },
      ],
    },
    {
      title: "EXAMS",
      links: [
        { label: "NEET UG", to: "/neet-ug", type: "link" },
        { label: "NEET PG", to: "/neet-pg", type: "link" },
        { label: "NEET MDS", to: "/neet-mds", type: "link" },
        { label: "INICET", to: "/inicet", type: "link" },
        { label: "DNB PDCET", to: "/dnb-pdcet", type: "link" },
        { label: "NEET SS", to: "/neet-ss", type: "link" },
      ],
    },
    {
      title: "LEGAL",
      links: [
        { label: "Privacy Policy", to: "/privacy-policy", type: "link" },
        { label: "Package Policy", to: "/package-policy", type: "link" },
        { label: "Terms & Conditions", to: "/terms-and-conditions", type: "link" },
      ],
    },
  ];

  return (
    <footer className="bg-grey-800 text-white px-6 py-10 rounded-3xl landing-3xs:my-6 m-4 landing-3xs:mx-6 ">
      <div className="max-landing-3xs:mx-auto mx-10 my-8 flex flex-col landing-md:flex-row justify-between items-center landing-3xs:items-start gap-10">
        <div className="flex flex-col justify-center items-center min-w-32 landing-3xs:items-start gap-4 landing-md:gap-5">
          <div className="flex items-center gap-2">
            <a href="/">
              <img
                src={images.logo}
                alt="ZyNerd Logo"
                className="w-60 h-16 transition-transform duration-300 hover:scale-105 object-contain cursor-pointer"
              />
            </a>
          </div>
          <div className="flex gap-2">
            <a
              className="transition-transform duration-300 hover:scale-105"
              href={getUtmLink()}
              target="_blank"
            >
              <img
                src={landingImages.googlePlayBadge}
                alt="Google Play"
                className="w-40 h-12 transition-transform duration-300 object-contain hover:scale-100"
              />
            </a>
            <a
              className="transition-transform duration-300 hover:scale-105"
              href="https://apps.apple.com/in/app/zynerd-neet-ug-pg-mds/id6504278658"
              target="_blank"
            >
              <img
                src={landingImages.appStoreBadge}
                alt="App Store"
                className="w-40 h-12 transition-transform duration-300 hover:scale-100 object-contain"
              />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 landing-3xs:grid-cols-2 landing-md:flex gap-10 text-center landing-3xs:text-left">
          {footerLinks.map((section, idx) => (
            <div key={idx}>
              <h3 className="font-bold text-xl !pb-4">{section.title}</h3>
              <ul className="font-medium space-y-4 landing-3xs:space-y-3 text-sm">
                {section.links.map((item, i) => (
                  <li key={i} className="text-grey-100">
                    {item.type === "link" ? (
                      <a
                        className="transition-transform duration-300 hover:scale-110 inline-block text-base leading-constrict text-grey-100"
                        href={item.to}
                      >
                        {item.label}
                      </a>
                    ) : (
                      <a
                        href={item.href}
                        className="transition-transform duration-300 hover:scale-110 inline-block text-base text-grey-100"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <p className="text-center text-sm text-grey-border mt-10">
        © 2025 Frank & David Labs Private Limited
      </p>
    </footer>
  );
};

export default Footer;
